import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function AddCart(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "AddCart", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M42.606 11.25H11.25l1.5 21h1.5v-.0075L39.246 30.87c.7041.0107 1.391-.218 1.9483-.6485.5572-.4306.9518-1.0375 1.1192-1.7215l3.3675-13.62c.088-.4484.0739-.9108-.0411-1.353-.1151-.4422-.3282-.8528-.6235-1.2014-.2953-.3487-.6653-.6264-1.0826-.8126-.4173-.1862-.8711-.2761-1.3278-.263Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m44.9105 18-.3675 1.5h-32.7l-.1125-1.5h33.18Zm-1.4858 6-.3675 1.5H12.2697l-.1125-1.5h31.2675Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m23.985 31.71-.735-20.46h-1.5v.03l.735 20.4975v.015l1.5-.0825Zm9.8025-.54L34.5 11.28v-.03H33l-.7125 19.9275c-.0012.0252.0013.0505.0075.075l1.4925-.0825Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M38.25 35.25h-24L12.945 6.546c-.0525-1.15686-.549-2.24894-1.3861-3.04909-.8372-.80015-1.9506-1.24675-3.10865-1.24691H3.75c-.39782 0-.77936.15804-1.06066.43934-.2813.2813-.43934.66284-.43934 1.06066 0 .39782.15804.77936.43934 1.06066.2813.2813.66284.43934 1.06066.43934h4.56675c.38628-.0004.75782.14823 1.03724.41494.27942.26671.44518.63093.46276 1.01681L11.121 35.3865c.0352.7718.3667 1.5002.9255 2.0336.5589.5334 1.3019.8307 2.0745.8299H19.5V39h3v-.75H33V39h3v-.75h2.25c.3978 0 .7794-.158 1.0607-.4393s.4393-.6629.4393-1.0607c0-.3978-.158-.7794-.4393-1.0607s-.6629-.4393-1.0607-.4393Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M3.75 2.25h4.5v3h-4.5c-.39782 0-.77936-.15804-1.06066-.43934C2.40804 4.52936 2.25 4.14782 2.25 3.75c0-.39782.15804-.77936.43934-1.06066.2813-.2813.66284-.43934 1.06066-.43934ZM21 45.75c2.0711 0 3.75-1.6789 3.75-3.75s-1.6789-3.75-3.75-3.75-3.75 1.6789-3.75 3.75 1.6789 3.75 3.75 3.75Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M21 43.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M34.5 45.75c2.0711 0 3.75-1.6789 3.75-3.75s-1.6789-3.75-3.75-3.75-3.75 1.6789-3.75 3.75 1.6789 3.75 3.75 3.75Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M34.5 43.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M32.25 14.2665V17.25h4.5l-8.25 9-8.25-9h4.5v-3c0-2.7848 1.1062-5.45549 3.0754-7.42462C29.7945 4.85625 32.4652 3.75 35.25 3.75h9.6675c.2208 0 .4325.08771.5887.24383.1561.15613.2438.36788.2438.58867 0 .18936-.0645.37306-.183.52075-.1185.14769-.2839.25052-.4687.2915L38.1233 6.945c-1.6659.37014-3.1557 1.29731-4.2236 2.62842C32.8319 10.9045 32.25 12.56 32.25 14.2665Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
AddCart.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "AddCart"
};
validateTidalLicense();
export {
  AddCart
};
//# sourceMappingURL=AddCart.js.map
